module.exports = __webpack_public_path__ + "img/logo_clk.20ee14f9.png";